import type { CharacterId } from "./core";
import type { LevelNumber } from "./levels";

export type { CharacterId } from "./core";

export interface HudSnapshot {
  hearts: number;
  gems: number;
  coins: number;
  wisdomStars: number;
}

export interface QuestionRequest {
  boxId: string;
  character: CharacterId;
  level: LevelNumber;
  questionIndex: number;
}

export interface TouchState {
  left: boolean;
  right: boolean;
  jump: boolean;
  magic: boolean;
}

export type GameBusEventMap = {
  "hud:update": HudSnapshot;
  "question:request": QuestionRequest;
  "question:resolved": { boxId: string };
  "game:complete": HudSnapshot;
  "game:hint": { message: string };
  "game:pause": undefined;
  "game:resume": undefined;
  "touch:update": TouchState;
  "audio:mute": { muted: boolean };
  "motion:reduced": { reduced: boolean };
};

type Listener<T> = (detail: T) => void;

class TypedGameBus {
  private target = new EventTarget();

  emit<K extends keyof GameBusEventMap>(name: K, detail: GameBusEventMap[K]): void {
    this.target.dispatchEvent(new CustomEvent(String(name), { detail }));
  }

  on<K extends keyof GameBusEventMap>(name: K, listener: Listener<GameBusEventMap[K]>): () => void {
    const wrapped = (event: Event) => listener((event as CustomEvent<GameBusEventMap[K]>).detail);
    this.target.addEventListener(String(name), wrapped);
    return () => this.target.removeEventListener(String(name), wrapped);
  }
}

export const gameBus = new TypedGameBus();

export const EMPTY_TOUCH_STATE: TouchState = {
  left: false,
  right: false,
  jump: false,
  magic: false
};
